const decalsAndSignageFaq = [
  {
    question: "What are decals and signage?",
    answer:
      "Decals are adhesive graphics or images that can be applied to various surfaces, such as windows, walls, and vehicles, for decorative or informational purposes. signage is usually large, flexible signs made of vinyl or fabric that are often used for promotional or event purposes.",
  },
  {
    question: "What surfaces are suitable for applying decals?",
    answer:
      "Decals can be applied to a variety of surfaces, including glass, metal, plastic, and even vehicles. They are versatile and can be used for both indoor and outdoor applications, providing a customizable solution for personal or business needs.",
  },
  {
    question:
      "What materials are used for signage, and what sizes are available?",
    answer:
      "signage are typically made of durable materials like vinyl or fabric. Sizes can vary widely, from small signs for tabletop displays to large outdoor signs for events. We offer customizable options to meet your specific size and material preferences.",
  },
  {
    question: "How long do decals typically last, and are they removable?",
    answer:
      "The lifespan of decals depends on factors like exposure to weather and sunlight. Indoor decals can last for years, while outdoor decals may have a shorter lifespan. Most decals are removable, and the ease of removal depends on the adhesive used. We can provide guidance on the best type of decal for your specific needs.",
  },
  {
    question: "Can you create custom designs for decals and signage?",
    answer:
      "Absolutely! We specialize in creating custom designs for decals and signage. Whether you have existing artwork or need assistance in designing something unique, our team is ready to collaborate and bring your vision to life. Contact us to discuss your specific design requirements.",
  },
];
export default decalsAndSignageFaq;
